<app-grouped-reservations-detail [reservation]="reservation"
                        (closeClick)="closeClicked()"
                        (detailsClick)="detailsClicked($event)"
                        (addClick)="addClicked()"
                                 [employees]="employees"
                                 [rooms]="rooms"
                                 [multiLanguage]="multiLanguage"
                        mat-dialog-content></app-grouped-reservations-detail>